import { Component, EventEmitter, h, State, Event } from '@stencil/core';

@Component({
  tag: 'test-basic',
  styleUrl: 'test-basic.css',
  shadow: true,
})

export class TestBasic {
  @State() value: string = '';
  @Event({ bubbles: true, composed: true }) inputChanged: EventEmitter<string>;

  onInput = (event: Event) => {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.inputChanged.emit(this.value); // Emit value to parent
  };
  render() {
    return <div>
      <ix-expanding-search 
        placeholder="Search..." 
        value={this.value} 
        onInput={this.onInput}>
      </ix-expanding-search>
    </div>;
  }
}
